<mat-toolbar class="header-toolbar" color="primary">
  <mat-toolbar-row>
    <div class="container">
      <div class="row between-xs middle-xs header-row">
        <nav>
          <a mat-button routerLink="/home" routerLinkActive="active">Home</a>
        </nav>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
